<div class="dialog-header">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <button
        *ngIf="data.export"
        mat-stroked-button
        class="custom-stroked-button-primary no-print"
        (click)="onExport()"
        [disabled]="data.isExporting">
        Exportar
        <mat-icon *ngIf="data.isExporting" iconPositionEnd>
        <mat-spinner diameter="15"></mat-spinner>
    </mat-icon>
    </button>
</div>

<div mat-dialog-content>
    <ng-container *ngIf="data.loaded || data.hasError; else loading">
        <app-mat-simple-table
            *ngIf="data.columns?.length; else emptyState"
            [columns]="data.columns"
            [data]="data.data">
        </app-mat-simple-table>
        <ng-template #emptyState>
            <div class="d-flex flex-column align-items-center">
                <mat-icon>search_off</mat-icon>
                <p>No hay datos para mostrar.</p>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #loading>
        <div class="data-loading">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    </ng-template>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
</div>
